import { selectsOrganization } from '@actions/organizations.actions';
import { createReducer, on } from '@ngrx/store';

export const organizationsKey = 'organizations';
export interface OrganizationsState {
  defaultGid: string;
}

export const initialState: OrganizationsState = {
  defaultGid: null
};

const reducer = createReducer(
  initialState,
  on(selectsOrganization, (state, { gid }) => ({ ...state, defaultGid: gid }))
);

export function organizationsReducer(state, action): OrganizationsState {
  return reducer(state, action);
}
